package site.shadadman.pages.worklog.bit24cash

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initJan112026Bit24MigratingToKMPPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("worklog/bit24cash/jan112026Bit24MigratingToKMP.md", FrontMatterElement.EmptyMap))
}

@Page("/worklog/bit24cash/jan112026-bit24-migrating-to-kmp")
@Composable
fun Jan112026Bit24MigratingToKMPPage() {
    org.jetbrains.compose.web.dom.H2(attrs = { id("jan-11-2026-bit24-migrating-to-kmp") }) {
        org.jetbrains.compose.web.dom.Text("jan-11-2026-bit24-Migrating-To-KMP")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Another opportunity to show myself at what I’m best at. When you can do one thing best, it gives you confidence and motivation to make it even better.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Our crypto exchange ecosystem, with over 2 million active users, was only targeting Android, and we were losing a significant portion of the iOS market. On the business side, migrating to KMP saves a decent amount of money in this situation by targeting iOS with minimum refactoring and the lowest estimation time, so they were very happy. On the engineers’ side, since all team members were Android developers, they all agreed this would be a good idea.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We were using Clean arch combined with MVI. Our project structure was quite unique & interesting. Each feature module was only had the presentation layer, data & domain for each feature were located inside the ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("services")
        }
        org.jetbrains.compose.web.dom.Text(" module. Something like this:")
    }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code { org.jetbrains.compose.web.dom.Text("""- user
    - presentation
- wallet
    - presentation
- ticket
    - presentation
- services
    - user
        - data
        - domain
    - wallet
        - data
        - domain
    - ticket
        - data
        - domain
""") } }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("I found this arch very effective and a brilliant idea. This not only separates ui from business logic in code it also separates it in module layer.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Migrating in this scale is not gonging to be easy. Our brainstorming meetings was a great. Solving a big problem requires breaking it down into smaller ones, which we achieved by asking ourselves a few key questions and then answering them very carefully:")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("should-we-start-the-migration-in-the-current-repo-or-fork-a-new-one") }) {
        org.jetbrains.compose.web.dom.Text("Should we start the migration in the current repo, or fork a new one?")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("what-are-the-project-dependencies-that-kmp-does-not-support") }) {
        org.jetbrains.compose.web.dom.Text("What are the project dependencies that KMP does not support?")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("what-features-need-platform-specific-implementation") }) {
        org.jetbrains.compose.web.dom.Text("What features need platform specific implementation?")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("which-modules-features-requires-the-least-most-refactoring") }) {
        org.jetbrains.compose.web.dom.Text("Which modules/features requires the least/most refactoring?")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("what-is-the-priority-order-for-modules-features") }) {
        org.jetbrains.compose.web.dom.Text("What is the priority order for modules/features?")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("how-can-we-use-ai-to-our-needs-what-prompts-are-most-effective") }) {
        org.jetbrains.compose.web.dom.Text("How can we use AI to our needs? What prompts are most effective?")
    }
}
